import { IPageTabNavLink } from "../interfaces-and-types";

export const invoicetemplateLink: IPageTabNavLink[] = [
    {
        name: 'Invoice Template',
        route: '',
    },
]